// Mock resources data for ResourcesScreen
export const mockResources = [
  {
    id: 'res-001',
    title: 'Fractions Visual Guide',
    type: 'PDF',
    category: 'Teaching Materials',
    gradeLevel: '5',
    subject: 'Math',
    thumbnail: 'https://via.placeholder.com/150/3B82F6/FFFFFF?text=PDF',
    description: 'Visual guide to help students understand fraction concepts using diagrams and real-world examples.',
    downloadUrl: '#'
  },
  {
    id: 'res-002',
    title: 'Decimal Place Value Worksheets',
    type: 'PDF',
    category: 'Worksheets',
    gradeLevel: '5',
    subject: 'Math',
    thumbnail: 'https://via.placeholder.com/150/8B5CF6/FFFFFF?text=PDF',
    description: 'Printable worksheets for practicing decimal place value concepts.',
    downloadUrl: '#'
  },
  {
    id: 'res-003',
    title: 'Math Vocabulary Cards',
    type: 'PDF',
    category: 'Teaching Materials',
    gradeLevel: 'K-5',
    subject: 'Math',
    thumbnail: 'https://via.placeholder.com/150/EC4899/FFFFFF?text=PDF',
    description: 'Printable vocabulary cards for key math terms with visual aids.',
    downloadUrl: '#'
  },
  {
    id: 'res-004',
    title: 'Number Line Activities',
    type: 'Video',
    category: 'Lesson Plans',
    gradeLevel: '3-5',
    subject: 'Math',
    thumbnail: 'https://via.placeholder.com/150/10B981/FFFFFF?text=Video',
    description: 'Video tutorial showing engaging number line activities for the classroom.',
    downloadUrl: '#'
  },
  {
    id: 'res-005',
    title: 'Fraction Games Lesson Plan',
    type: 'Document',
    category: 'Lesson Plans',
    gradeLevel: '5',
    subject: 'Math',
    thumbnail: 'https://via.placeholder.com/150/F59E0B/FFFFFF?text=Doc',
    description: 'Complete lesson plan with hands-on fraction games for engaging classroom activities.',
    downloadUrl: '#'
  },
  {
    id: 'res-006',
    title: "Parent's Guide to Supporting Math Learning",
    type: 'PDF',
    category: 'Parent Resources',
    gradeLevel: 'K-8',
    subject: 'Math',
    thumbnail: 'https://via.placeholder.com/150/EF4444/FFFFFF?text=PDF',
    description: "Guide for parents on how to support their child's math learning at home.",
    downloadUrl: '#'
  },
];
